import React from 'react';
import IconButton from '#/components/Form/IconButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_NAMES } from '#/router/routes';
import IconWithContextMenu from '#/components/Form/IconWithContextMenu';
import useAuth from '#/hooks/useAuth';

const iconButtonTailwindStyle = 'bg-theme-black opacity-60 pointer-events-auto';

const TopNavBar = () => {
  const { removeAuth } = useAuth();

  const location = useLocation();

  const navigate = useNavigate();

  const handleGoBack = () => {
    if (location.key !== 'default') {
      navigate(-1);
    }
  };

  const handleGoForward = () => navigate(1);

  const handleLogout = () => {
    removeAuth();
    navigate(ROUTE_NAMES.LOGIN);
  };

  return (
    <div className=" sticky top-0 flex justify-between w-full z-50 pt-4 px-theme-page-padding h-theme-top-bar-height pointer-events-none">
      <div className="flex gap-2">
        <IconButton
          className={iconButtonTailwindStyle}
          icon="navigate_before"
          onClick={handleGoBack}
        />
        <IconButton
          className={iconButtonTailwindStyle}
          icon="navigate_next"
          onClick={handleGoForward}
        />
      </div>
      <IconWithContextMenu
        contextMenuLimit="r"
        className={iconButtonTailwindStyle}
        icon="person"
        contextMenuItems={[
          { text: 'Profile', onClick: ROUTE_NAMES.PROFILE },
          { text: 'Log out', onClick: handleLogout },
        ]}
      />
    </div>
  );
};

export default TopNavBar;
